

export const getBlobImg = async (dataUrl ) => {

  
        // Определите MIME-тип изображения
        const mimeType = dataUrl.split(';')[0].split(':')[1];
    
        // Преобразуйте Data URL в Blob
        const response = await fetch(dataUrl);
        const blob = await response.blob();
    
        // Создайте File из Blob, если это необходимо
        // const file = new File([blob], 'filename.png', { type: mimeType });
    
        return blob;
  
}